module.exports = __webpack_public_path__ + "img/P669205801.5d250e1a.jpg";